/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiBillingList.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-billing-list";

export class AutogenModelEdiBillingList<RowType extends ModelRow> extends Endpoint<RowType, RowEdiBillingListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiBillingList extends ModelRow<RowEdiBillingListFields> {
	constructor(values?: Partial<RowEdiBillingListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiBillingListFields {
	agent: string;
	alt_partner_id: string;
	autorate_status: string;
	batch: number;
	bill_date: Date;
	bill_tid: number;
	bill_type: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_id: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	booking_number: string;
	broker: string;
	carrier_id: string;
	carrier_tractor: string;
	carrier_trailer: string;
	cc_pro_nbr: string;
	commodity: string;
	commodity_descr: string;
	company_id: string;
	"consignee.actual_arrival": Date;
	"consignee.actual_departure": Date;
	"consignee.address": string;
	"consignee.address2": string;
	"consignee.appointment_status_id": string;
	"consignee.appt_contact_name": string;
	"consignee.appt_required": string;
	"consignee.cases": number;
	"consignee.city_id": number;
	"consignee.city_name": string;
	"consignee.company_id": string;
	"consignee.confirmed": string;
	"consignee.contact_email": string;
	"consignee.contact_name": string;
	"consignee.dist_from_prev": number;
	"consignee.dist_from_prev_um": string;
	"consignee.driver_load_unload": string;
	"consignee.edi_code": string;
	"consignee.edi_loc_code": string;
	"consignee.eta": Date;
	"consignee.eta_distance": number;
	"consignee.eta_late": string;
	"consignee.eta_oor": string;
	"consignee.google_place_id": string;
	"consignee.grouped_id": number;
	"consignee.hub": number;
	"consignee.ic_stop_id": string;
	"consignee.id": string;
	"consignee.inbound_status": string;
	"consignee.late_eta_colorcode": string;
	"consignee.late_route_status": string;
	"consignee.latitude": number;
	"consignee.location_id": string;
	"consignee.location_name": string;
	"consignee.longitude": number;
	"consignee.manifest_fgp_uid": number;
	"consignee.manifest_reg_uid": number;
	"consignee.move_dist_from_preassign": number;
	"consignee.move_dist_from_preassign_um": string;
	"consignee.move_dist_from_previous": number;
	"consignee.move_dist_from_previous_um": string;
	"consignee.movement_id": string;
	"consignee.movement_sequence": number;
	"consignee.operational_status": string;
	"consignee.order_id": string;
	"consignee.order_sequence": number;
	"consignee.orig_sched_early": Date;
	"consignee.orig_sched_late": Date;
	"consignee.pallets_dropped": number;
	"consignee.pallets_picked_up": number;
	"consignee.payment_code_reviewed": string;
	"consignee.phone": string;
	"consignee.planned_arrival_time": Date;
	"consignee.ponum": string;
	"consignee.prior_uncleared_stops": string;
	"consignee.projected_arrival": Date;
	"consignee.pu_override_arrive_early": Date;
	"consignee.pu_override_arrive_late": Date;
	"consignee.rate_dist_from_previous": number;
	"consignee.rate_dist_from_previous_um": string;
	"consignee.refno": string;
	"consignee.requested_service": string;
	"consignee.sched_arrive_early": Date;
	"consignee.sched_arrive_late": Date;
	"consignee.seal": string;
	"consignee.service_date": Date;
	"consignee.showas_address": string;
	"consignee.showas_address2": string;
	"consignee.showas_city_id": number;
	"consignee.showas_city_name": string;
	"consignee.showas_location_id": string;
	"consignee.showas_location_name": string;
	"consignee.showas_state": string;
	"consignee.showas_zip_code": string;
	"consignee.signed_for_name": string;
	"consignee.state": string;
	"consignee.status": string;
	"consignee.stop_type": string;
	"consignee.trimble_place_id": string;
	"consignee.txl_uid": number;
	"consignee.volume": number;
	"consignee.volume_um": string;
	"consignee.weight": number;
	"consignee.weight_um": string;
	"consignee.zip_code": string;
	"consignee.zone_id": string;
	consignee_ref_no: string;
	consignee_stop_id: string;
	container: string;
	correction_ind: string;
	create_date: Date;
	currency: string;
	currency_iso_id: string;
	currency_type_id: string;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.auto_rate": string;
	"customer.auto_tax": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.carrier_scorecard_exported": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.gp_imported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.integration_type": string;
	"customer.invoice_processing_id": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.override_max_city_radius": number;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.toll_oc_exempt": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	customer_ediloc: string;
	customer_id: string;
	delivery_date: Date;
	direction: string;
	dist_include_split: string;
	distance: number;
	distance_um: string;
	driver_id: string;
	edi_billing_blnum: string;
	edi_billing_shipment_id: string;
	edi_billing_status: string;
	edi_commodity_id: string;
	edi_equip_type_id: string;
	edi_error: number;
	"edi_template.ack_required": string;
	"edi_template.app_receiver_code": string;
	"edi_template.app_receiver_id": string;
	"edi_template.app_sender_code": string;
	"edi_template.app_sender_id": string;
	"edi_template.authen_info": string;
	"edi_template.authen_info_qual": string;
	"edi_template.company_id": string;
	"edi_template.ctl_version": string;
	"edi_template.ctl_version_qual": string;
	"edi_template.descr": string;
	"edi_template.direction": string;
	"edi_template.ele_separator": number;
	"edi_template.end_of_line_1": number;
	"edi_template.end_of_line_2": number;
	"edi_template.filepath": string;
	"edi_template.format_type": string;
	"edi_template.functional_id": string;
	"edi_template.id": number;
	"edi_template.industry": string;
	"edi_template.is_multi_partner": string;
	"edi_template.name": string;
	"edi_template.parse_batch_number": string;
	"edi_template.parse_create_date": string;
	"edi_template.parse_create_datef": string;
	"edi_template.parse_fg_segment": string;
	"edi_template.parse_tran_ctrl_no": string;
	"edi_template.parse_tran_segment": string;
	"edi_template.receiver_id": string;
	"edi_template.receiver_qual": string;
	"edi_template.secur_info": string;
	"edi_template.secur_info_qual": string;
	"edi_template.sender_id": string;
	"edi_template.sender_qual": string;
	"edi_template.spec_footer_text": string;
	"edi_template.spec_header_text": string;
	"edi_template.spec_title": string;
	"edi_template.standard": string;
	"edi_template.subele_separator": number;
	"edi_template.tag_format_text": string;
	"edi_template.test_indicator": string;
	"edi_template.transaction_set": string;
	"edi_template.transaction_type": string;
	"edi_template.translation_method": string;
	"edi_template.update_date": Date;
	"edi_template.version": string;
	edi_transfered: string;
	"edibilling_profile.ack_xmit_method": string;
	"edibilling_profile.allow_corrections": string;
	"edibilling_profile.allow_xfer_after_settlement": string;
	"edibilling_profile.alt_partner_id": string;
	"edibilling_profile.always_update_stop": string;
	"edibilling_profile.apply_chassis_adds": string;
	"edibilling_profile.apply_container_adds": string;
	"edibilling_profile.apply_ep_adds": string;
	"edibilling_profile.apply_ep_chgs": string;
	"edibilling_profile.apply_ep_dels": string;
	"edibilling_profile.apply_frt_adds": string;
	"edibilling_profile.apply_frt_chgs": string;
	"edibilling_profile.apply_frt_dels": string;
	"edibilling_profile.apply_hdr_adds": string;
	"edibilling_profile.apply_hdr_chgs": string;
	"edibilling_profile.apply_hdr_dels": string;
	"edibilling_profile.apply_move_chgs": string;
	"edibilling_profile.apply_note_adds": string;
	"edibilling_profile.apply_note_dels": string;
	"edibilling_profile.apply_oc_adds": string;
	"edibilling_profile.apply_oc_chgs": string;
	"edibilling_profile.apply_oc_dels": string;
	"edibilling_profile.apply_order_chgs": string;
	"edibilling_profile.apply_refno_adds": string;
	"edibilling_profile.apply_refno_chgs": string;
	"edibilling_profile.apply_refno_dels": string;
	"edibilling_profile.apply_stop_adds": string;
	"edibilling_profile.apply_stop_chgs": string;
	"edibilling_profile.apply_stop_dels": string;
	"edibilling_profile.audit_cutoff_days": number;
	"edibilling_profile.audit_interval": number;
	"edibilling_profile.auto_accept": string;
	"edibilling_profile.auto_compare": string;
	"edibilling_profile.auto_compare_rt": string;
	"edibilling_profile.auto_create_order": string;
	"edibilling_profile.auto_deliver_order": string;
	"edibilling_profile.auto_rate": string;
	"edibilling_profile.carrier_id": string;
	"edibilling_profile.company_id": string;
	"edibilling_profile.compare_update": string;
	"edibilling_profile.days_to_retain": number;
	"edibilling_profile.direction": string;
	"edibilling_profile.edi_comm_id": number;
	"edibilling_profile.enf_batch_cont": string;
	"edibilling_profile.enf_batch_cont_997": string;
	"edibilling_profile.english_printer": string;
	"edibilling_profile.error_options": string;
	"edibilling_profile.error_rpt_printer": string;
	"edibilling_profile.fa_threshold": number;
	"edibilling_profile.filename": string;
	"edibilling_profile.func_ack_filename": string;
	"edibilling_profile.func_ack_st02_frmt": string;
	"edibilling_profile.func_ack_tid": number;
	"edibilling_profile.func_altpartner_id": string;
	"edibilling_profile.func_comm_id": number;
	"edibilling_profile.func_next_batch": number;
	"edibilling_profile.func_partner_id": string;
	"edibilling_profile.func_use_m_batch": string;
	"edibilling_profile.func_version": string;
	"edibilling_profile.id": string;
	"edibilling_profile.img_def_loc_dir": string;
	"edibilling_profile.img_dir_local": string;
	"edibilling_profile.img_document_types": string;
	"edibilling_profile.img_filetype": string;
	"edibilling_profile.img_required": string;
	"edibilling_profile.individual_batch": string;
	"edibilling_profile.intercompany": string;
	"edibilling_profile.next_batch": number;
	"edibilling_profile.notes": string;
	"edibilling_profile.partner_id": string;
	"edibilling_profile.partner_name": string;
	"edibilling_profile.print_before_send": string;
	"edibilling_profile.print_bills": string;
	"edibilling_profile.process_priority": number;
	"edibilling_profile.purge_rpt_printer": string;
	"edibilling_profile.remove_file": string;
	"edibilling_profile.send_func_ack": string;
	"edibilling_profile.send_to_company": string;
	"edibilling_profile.skip_manual_orders": string;
	"edibilling_profile.special_processing": string;
	"edibilling_profile.st02_format": string;
	"edibilling_profile.template_id": number;
	"edibilling_profile.transaction_set": string;
	"edibilling_profile.transmit_method": string;
	"edibilling_profile.updaterecs_how": string;
	"edibilling_profile.use_master_batch": string;
	"edibilling_profile.use_ok2send": string;
	"edibilling_profile.use_show_as": string;
	"edibilling_profile.version": string;
	"edibilling_profile.zip_filename": string;
	"edibilling_profile.zip_images": string;
	entered_user_id: string;
	equipment_type_id: string;
	error_text: string;
	error_type: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	external_invoiceno: string;
	factoring_exp_date: Date;
	factoring_id: string;
	fixed_charge_label: string;
	fixed_charge_seg_alloc_code: string;
	freight_class: string;
	frt_grp_pro_nbr: string;
	func_ack_batch: number;
	func_ack_id: string;
	func_ack_rec: string;
	func_ack_rec_date: Date;
	func_ack_status: string;
	gs06_group_cntlno: string;
	gs_date_time: Date;
	handling_code1: string;
	handling_code2: string;
	has_error_out: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	intercompany: string;
	invoice_no: number;
	invoice_no_string: string;
	invoice_recv_date: Date;
	invoiced_flag: string;
	is_balance_due: string;
	is_dedicated_bill: string;
	is_fixed: string;
	is_intercompany: string;
	is_rebill: string;
	is_split_bill: string;
	linehaul_chg: number;
	linehaul_chg_c: string;
	linehaul_chg_d: Date;
	linehaul_chg_n: number;
	linehaul_chg_r: number;
	lock_miles: string;
	master_order_id: string;
	minimum_weight: number;
	minimum_weight_um: string;
	modified_date: Date;
	modified_user_id: string;
	movement_id: string;
	order_id: string;
	order_type_id: string;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.carrier_scorecard_export_dt": Date;
	"orders.carrier_scorecard_exported": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.dat_loadboard_refid": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_last_refresh": Date;
	"orders.loadboard_post_movement_id": string;
	"orders.loadboard_posting_cancelled": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_length": number;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	other_charge: number;
	other_charge_c: string;
	other_charge_d: Date;
	other_charge_n: number;
	other_charge_r: number;
	partner_id: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	payment_method: string;
	pieces: number;
	pieces_qual: string;
	port: string;
	post_key: string;
	post_module: string;
	printed: string;
	pro_nbr: string;
	purchase_order_no: string;
	rate: number;
	rate_id: number;
	rate_type: string;
	rate_unit_desc: string;
	rating_method: string;
	rating_type: string;
	rating_units: number;
	ready_to_process: string;
	ready_to_send: string;
	rebilled: string;
	reference_id: string;
	revenue_id: string;
	round_trip_flag: string;
	route_code: string;
	route_qual: string;
	scac: string;
	service_code: string;
	ship_date: Date;
	ship_match_descr: string;
	ship_match_type: string;
	shipment_id: string;
	"shipper.actual_arrival": Date;
	"shipper.actual_departure": Date;
	"shipper.address": string;
	"shipper.address2": string;
	"shipper.appointment_status_id": string;
	"shipper.appt_contact_name": string;
	"shipper.appt_required": string;
	"shipper.cases": number;
	"shipper.city_id": number;
	"shipper.city_name": string;
	"shipper.company_id": string;
	"shipper.confirmed": string;
	"shipper.contact_email": string;
	"shipper.contact_name": string;
	"shipper.dist_from_prev": number;
	"shipper.dist_from_prev_um": string;
	"shipper.driver_load_unload": string;
	"shipper.edi_code": string;
	"shipper.edi_loc_code": string;
	"shipper.eta": Date;
	"shipper.eta_distance": number;
	"shipper.eta_late": string;
	"shipper.eta_oor": string;
	"shipper.google_place_id": string;
	"shipper.grouped_id": number;
	"shipper.hub": number;
	"shipper.ic_stop_id": string;
	"shipper.id": string;
	"shipper.inbound_status": string;
	"shipper.late_eta_colorcode": string;
	"shipper.late_route_status": string;
	"shipper.latitude": number;
	"shipper.location_id": string;
	"shipper.location_name": string;
	"shipper.longitude": number;
	"shipper.manifest_fgp_uid": number;
	"shipper.manifest_reg_uid": number;
	"shipper.move_dist_from_preassign": number;
	"shipper.move_dist_from_preassign_um": string;
	"shipper.move_dist_from_previous": number;
	"shipper.move_dist_from_previous_um": string;
	"shipper.movement_id": string;
	"shipper.movement_sequence": number;
	"shipper.operational_status": string;
	"shipper.order_id": string;
	"shipper.order_sequence": number;
	"shipper.orig_sched_early": Date;
	"shipper.orig_sched_late": Date;
	"shipper.pallets_dropped": number;
	"shipper.pallets_picked_up": number;
	"shipper.payment_code_reviewed": string;
	"shipper.phone": string;
	"shipper.planned_arrival_time": Date;
	"shipper.ponum": string;
	"shipper.prior_uncleared_stops": string;
	"shipper.projected_arrival": Date;
	"shipper.pu_override_arrive_early": Date;
	"shipper.pu_override_arrive_late": Date;
	"shipper.rate_dist_from_previous": number;
	"shipper.rate_dist_from_previous_um": string;
	"shipper.refno": string;
	"shipper.requested_service": string;
	"shipper.sched_arrive_early": Date;
	"shipper.sched_arrive_late": Date;
	"shipper.seal": string;
	"shipper.service_date": Date;
	"shipper.showas_address": string;
	"shipper.showas_address2": string;
	"shipper.showas_city_id": number;
	"shipper.showas_city_name": string;
	"shipper.showas_location_id": string;
	"shipper.showas_location_name": string;
	"shipper.showas_state": string;
	"shipper.showas_zip_code": string;
	"shipper.signed_for_name": string;
	"shipper.state": string;
	"shipper.status": string;
	"shipper.stop_type": string;
	"shipper.trimble_place_id": string;
	"shipper.txl_uid": number;
	"shipper.volume": number;
	"shipper.volume_um": string;
	"shipper.weight": number;
	"shipper.weight_um": string;
	"shipper.zip_code": string;
	"shipper.zone_id": string;
	shipper_stop_id: string;
	splc: string;
	st02_trxset_cntlno: string;
	status: string;
	total_charges: number;
	total_charges_c: string;
	total_charges_d: Date;
	total_charges_n: number;
	total_charges_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_id: string;
	trailer2_id: string;
	trailer_id: string;
	trans_count: number;
	transfer_date: Date;
	transport_method: string;
	version: string;
	vessel: string;
	void_credit_immediately: string;
	weight: number;
	weight_qual: string;
	weight_um: string;
	batch_beginning: number;
	batch_ending: number;
	batch_history_batch: number;
	batch_history_create_date: Date;
	batch_history_transaction_sequence: number;
	batch_range: boolean;
	error_description: string;
	error_type: string;
	errors: boolean;
	search_reference_numbers: string;
}

